import axios from "axios";

// 创建 axios 实例
const apiClient = axios.create({
  // baseURL: "http://192.168.3.8:9988", // 设置基础URL
  baseURL: "http://www.168cable.com",
  timeout: 60000, // 请求超时时间
  headers: {
    "Content-Type": "application/json",
  },
});

// GET 请求
export const getRequest = (url, params = {}) => {
  return apiClient.get(url, { params });
};

// POST 请求
export const postRequest = (url, data = {}) => {
  return apiClient.post(url, data);
};

// PUT 请求
export const putRequest = (url, data = {}) => {
  return apiClient.put(url, data);
};

// DELETE 请求
export const deleteRequest = (url) => {
  return apiClient.delete(url);
};
